module.exports = __webpack_public_path__ + "images/marketing_site/x-mailer-2026.png";